import { axiosInstanceMyBodytech, axiosInstanceProducts } from "./instance";

export const getUser = (uuid) => {
  return axiosInstanceMyBodytech.get(`users/uuid/${uuid}`);
};

export const updateContact = (id, data) => {
  return axiosInstanceProducts.put(`notifications/update-accept-contact/${id}`, data);
};
